import { createSlice } from '@reduxjs/toolkit';

const initialState = {
  modalInfo: {
    isOpen: false,
    isData: {},
  },
  userDetailsModal: {
    userModalOpen: false,
    userModalData: {},
  },
};

export const modalSlice = createSlice({
  name: 'modal',
  initialState,
  reducers: {
    openModalGlobal: (state, action) => {
      state.modalInfo = action.payload;
    },
    closeModalGlobal: (state, action) => {
      state.modalInfo = action.payload;
    },
    openUserDetailsModal: (state, action) => {
      state.userDetailsModal = action.payload;
    },
    closeUserDetailsModal: (state, action) => {
      state.userDetailsModal = action.payload;
    },
  },
});

export const {
  openModalGlobal,
  closeModalGlobal,
  openUserDetailsModal,
  closeUserDetailsModal,
} = modalSlice.actions;

export default modalSlice.reducer;
